import React, { FC } from 'react'

import { DemoPopup } from 'pages/soundscape-page/components/DemoPopup'

import bg from './assets/smart-bg.jpg'
import mobileBg from './assets/smart-bg-mobile.jpg'

import type { SoundscapeDemoPopupContent } from 'redux/popupReducer'

interface SoundscapeSmartProps {
  content: SoundscapeDemoPopupContent
}

export const SoundscapeSmart: FC<SoundscapeSmartProps> = ({ content }) => {
  return (
    <DemoPopup
      backgroundImage={bg}
      mobileBackgroundImage={mobileBg}
      logo={content.logoUrl}
      title={content.title}
      description={content.description}
    />
  )
}
